<template>
  <div>
    <ul class="list">
      <li class="list-item"
          v-for="item in ExtendList"
          @click="SkipExtend(item)"
          :key="item.name">
        <div class="head">
          <div>
            <img :src="require('../../../../public/img/demo/'+item.icon)"
                 width="30px"
                 height="30px"
                 alt="">
          </div>
          <span>{{ item.name }}</span>
        </div>
        <p class="text">{{ item.text }}</p>
        <p class="desc">{{ item.rests }}</p>
      </li>
    </ul>

    <dialog-reset :visible.sync="dialogVisible"
                  top="1vh"
                  width="80%"
                  height="83vh"
                  title="VueJs">
      <div class="iframe-box">
        <iframe id="iframe"
                height="750px"
                width="100%"
                src="https://v2.cn.vuejs.org/v2/style-guide"
                frameborder="0"></iframe>
      </div>
    </dialog-reset>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      // 扩展内容
      ExtendList: [
        {
          name: 'Vue 2.x 风格指南',
          text: '渐进式 JS 框架 Vue, 协助你规范的写 Vue',
          rests: 'bladex架底层的 JS 渐近式框架',
          icon: 'Vue.jpg',
          refuseNew: true,

        },
        {
          name: 'Avue',
          text: '前端搬砖神器,让数据驱动视图,更加贴合企业开发',
          rests: '基于ElelentUi二次构建 源码托管在 Gitee',
          icon: 'avue.png',
          url: 'https://avuejs.com/'
        },
        {
          name: 'ElementUI',
          text: '最受欢迎的vue2.x UI框架',
          rests: '项目使用的主要 Ui 框架 源码托管在 GitHub',
          icon: 'element.jpg',
          url: 'https://element.eleme.cn/#/zh-CN/'
        },
        {
          name: 'vxetable',
          text: '为你Vue中的表格提供最好的解决方案',
          rests: '专注于表格组件的Ui框架 源码托管在 Gitee',
          icon: 'vxe.png',
          url: 'https://vxetable.cn/#/table/edit/dblclick'
        },
        {
          name: '想学习 Vue3 + vite ？',
          text: 'Admin Pro是一个优秀的开源项目,',
          rests: 'vite 将比 webpack 快数倍 ',
          icon: 'github.jpg',
          url: 'https://gitee.com/lin0716/gi-demo'
        },
        {
          name: '你拥有阿里p7的水平 ？',
          text: 'C++ GO nodeJS python... 通往更广阔世界的路 English Top 榜',
          rests: 'github网站 进不去挂梯子',
          icon: 'github.jpg',
          url: 'https://github.com/GrowingGit/GitHub-English-Top-Charts'
        },

      ],
    };
  },
  methods: {
    SkipExtend(row) {
      if (!row.refuseNew)
        window.open(row.url, '_blank')
      else
        this.dialogVisible = true
    }
  }
};
</script>

<style lang="scss" scoped>
.list {
  li {
    list-style: none;
  }
  display: flex;
  flex-wrap: wrap;
  .list-item {
    flex: 1;
    min-width: 400px;
    color: var(--color-text-3);
    line-height: 1.5;
    padding: 10px;
    box-sizing: border-box;
    transition: all 0.3s;
    &:hover {
      cursor: pointer;
      border-radius: 4px;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
    }
    .head {
      display: flex;
      align-items: center;
      span {
        margin-left: 10px;
        font-size: 1.125rem;
        line-height: 1.75rem;
        color: var(--color-text-2);
      }
    }
    .text {
      margin-top: 10px;
      height: 50px;
    }
    .desc {
      font-size: 12px;
    }
  }
}

.iframe-box {
  padding: 10px;
}
</style>
